module.exports = __webpack_public_path__ + "build/assets/TruenoSBd-de4246d54c510bf4556d2410801fc6db.woff";